import { loginUrl } from './util';
import request from '@/utils/request';

import type { ProductModule, IProductItem } from '@/components/MembersDay/type';

export type ResponseObj<T = unknown> = {
    code: string;
    data: T;
    message: string;
};

/**
 * 查询累计金额和优惠券等信息
 */
export const getTotalPriceInfo = (locale: string): Promise<ResponseObj<any>> =>
    request.post(`${loginUrl(locale)}/integral/web/memberStore/getTotalPriceInfo`, { data: {}, needToken: true });

/**
 * 查询普通产品列表
 * bizModule 区分会员和日常store
 */
export const getListProducts = (params: { module: ProductModule; bizModule: string }, locale: string): Promise<ResponseObj<IProductItem[]>> =>
    request.post(`${loginUrl(locale)}/integral/web/rewardProduct/listProducts`, { data: params, needToken: false });

/**
 * 查询产品列表(配件)
 * bizModule 区分会员和日常store
 */
export const getListProducts2 = (params: { module: ProductModule; bizModule: string }, locale: string): Promise<ResponseObj<IProductItem[]>> =>
    request.post(`${loginUrl(locale)}/integral/app/rewardProduct/listProducts`, { data: params, needToken: false });

/**
 * memberStore查询优惠券列表
 */
export const getCouponListForMember = (locale: string): Promise<ResponseObj<any>> =>
    request.post(`${loginUrl(locale)}/integral/web/rewardRedeemCoupon/listCouponForMemberStore`, { data: {}, needToken: true });

/**
 * memberStore优惠券领取接口
 */
export const receiveForMemberStore = (data: { discountId: string; discountVersion: string }, locale: string): Promise<ResponseObj<any>> =>
    request.post(`${loginUrl(locale)}/integral/web/rewardRedeemCoupon/discount/receiveForMemberStore`, { data, needToken: true });
